import Immutable, { Record } from 'immutable';
import { Gender } from 'omni-common-ui';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];
    case 'gender':
      return [key, Gender.parse(val)];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

const UserRecord = Record({
  avatarUrl: undefined,
  id: undefined,
  userName: undefined,
  userEmail: undefined,
  firstName: undefined,
  middleName: undefined,
  lastName: undefined,
  firstNameLocal: undefined,
  middleNameLocal: undefined,
  lastNameLocal: undefined,
  gender: undefined,
});

class User extends UserRecord {
  static create(data) {
    return new User(data).mapEntries(reviver);
  }
}

export default User;



// WEBPACK FOOTER //
// ./data/Users/model.js